/* assets/ukomi-productpush.js */
(function () {
  // ----- 設定 -----
  // Worker
  var WORKER_ENDPOINT = 'https://ukomi.maruzenjunkudo.co.jp/';

  // ----- Bot 判定（c.f. honto-link.js） -----
  var UA = navigator.userAgent || '';

  var IS_BOT = (function () {
    var ua = (UA || '').toLowerCase();
    if (!ua) return false;
    // レンダリングBotやプレビューBotも含めて広めにブロック
    return /bot|crawler|spider|crawling|googlebot|bingbot|yandex|baidu|duckduckbot|slurp|adsbot|mediapartners-google|facebookexternalhit|twitterbot|linkedinbot|applebot|pinterest|embedly|quora|whatsapp|telegrambot|discordbot|preview/i.test(ua);
  })();

  // ----- 商品ハンドルの取得 -----
  function getProductHandleFromLocation() {
    var path = window.location.pathname.split('?')[0];
    var parts = path.split('/').filter(Boolean);
    var i = parts.indexOf('products');
    if (i === -1 || i + 1 >= parts.length) return null;

    var handle = parts[i + 1].split('.')[0];

    // ISBN-13 / JAN 前提なら数値ハンドルだけに絞る
    if (!/^\d{9,13}$/.test(handle)) return null;

    return handle;
  }

  // ----- U-KOMI ウィジェット有無を見て Worker を叩く -----
  function callWorker(handle) {
    if (!handle) return;
    if (window.__ukomiProductPushFired) return;
    window.__ukomiProductPushFired = true;

    // Origin / Referer / Cookie などはブラウザが自動で付与
    fetch(WORKER_ENDPOINT + '?handle=' + encodeURIComponent(handle), {
      method: 'GET',
      mode: 'cors',
      // same-origin がデフォルトなので ukomi.* へ Cookie は飛ばない
    }).catch(function (e) {
      if (window.console && console.warn) {
        console.warn('u-komi product push failed', e);
      }
    });
  }

  function startCheck(handle) {
    if (!handle) return;

    var maxChecks = 10;       // 0.5s × 10 = 最大約5秒待つ
    var intervalMs = 500;
    var count = 0;

    var timer = setInterval(function () {
      count += 1;

      // U-KOMI の「レビューを書く」ボタンが出ていれば何もしない
      var btn = document.querySelector('.uKomiWidgetWriteReviewBtn');
      if (btn) {
        clearInterval(timer);
        return;
      }

      // 規定回数待ってもボタンが出てこなければ、自動登録を試みる
      if (count >= maxChecks) {
        clearInterval(timer);
        callWorker(handle);
      }
    }, intervalMs);
  }

  function run() {
    if (IS_BOT) return; // Bot には一切何もしない

    var handle = getProductHandleFromLocation();
    if (!handle) return;

    startCheck(handle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
